'use client';

import { Button, Container, Typography } from '@mui/material';
import cx from 'clsx';

import { Link } from '@/i18n/navigation';
import { Link as LinkType } from '@/types/link.type';

import styles from './SectionTitleSimple.module.scss';

// TODO: Use this on other places as well

interface SectionTitleSimpleProps {
  title: string;
  description: string;
  link: LinkType;
  className?: string;
}

const SectionTitleSimple = ({ title, description, link, className }: SectionTitleSimpleProps) => (
  <Container maxWidth="xl" className={cx(styles.container, className)}>
    <Typography variant="h2" textAlign="center" className={styles.title}>
      {title}
    </Typography>
    <Typography variant="body1" textAlign="center" className={styles.description}>
      {description}
    </Typography>
    <Link href={link.href as '/'} target={link.target}>
      <Button>{link.text}</Button>
    </Link>
  </Container>
);

export default SectionTitleSimple;
